import { JSX } from "react";

import { Box, styled, Typography, useTheme } from "@mui/material";
import { t } from "i18next";
import { WeatherItem } from "src/types/weatherItemDto";

import { getUnicodeSymbol } from "../../../helpers/dashboardChart.helper";

const styles = {
  box: { display: "flex", alignItems: "center", textAlign: "right", gap: 1 },
};

const WeatherSymbol = styled("span")(({ theme }) => ({
  fontFamily: "weathericons",
  fontSize: theme.fontSizes.md,
}));

function WeatherForecast({ forecast }: { forecast: WeatherItem }): JSX.Element {
  const theme = useTheme();

  return (
    <Box sx={styles.box}>
      <Typography variant='body2' component='div'>
        {forecast.ApparentTempHigh}°C{" "}
        <Box component='span' color={theme.palette.text.secondary}>
          {forecast.ApparentTempLow}°C
        </Box>
      </Typography>

      <WeatherSymbol>{getUnicodeSymbol(forecast.Status)}</WeatherSymbol>

      <Typography variant='body2' component='div'>
        {t(forecast.Status)}
      </Typography>
    </Box>
  );
}

export default WeatherForecast;
